import { PARENT_TAGLINE } from "../brands";

export function Footer() {
  return (
    <footer className="border-t border-jw-border">
      <div className="mx-auto max-w-6xl px-6 py-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-display text-sm jw-wordmark tracking-wide">WARD SYSTEMS</p>
          <p className="font-mono text-[0.65rem] tracking-[0.22em] uppercase text-jw-chrome-dim mt-1">
            {PARENT_TAGLINE}
          </p>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-jw-text-muted">
          <a href="/brief" className="hover:text-jw-steel-light transition">
            Founder Brief
          </a>
          <a
            href="mailto:hello@wardtechsystems.com"
            className="hover:text-jw-steel-light transition"
          >
            Contact
          </a>
          <span className="font-mono text-[0.65rem] tracking-[0.18em] uppercase text-jw-text-subtle">
            © {new Date().getFullYear()}
          </span>
        </nav>
      </div>
    </footer>
  );
}
